var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#pattern0_171_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_171_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_171_2",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_171_2",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAALdAAAC3QHkSGdAAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAASNQTFRF////5FtJ5VhP4ldMxkM1xUI1xkI2xkI2xkM2x0M2x0M3x0M3x0Q4x0Q4yUQ44lZN4ldMtTYpuTksxUI13VRI4ldM4lhN41xS42BV5GFX5GRZ5WVb5Wdd5Wlf5mxi5m9l5m9m5nBn5nFn53du6Hxz6X516YF46YF56oR864yE7JGK7JOM7ZaP7ZmS7puU7p6Y7p+Z76Gb76Wf8Kei8Kmj8a2o8a6p8a+p8a+q8bGr8rKt8rOu8rWw8rax87q187u39L669MG99cbC9cfD9snF9svI9szI99HO99LP+NbT+NfV+d7c+uPh++fm/Ovq/O3r/O3s/O7t/O/t/O/u/PHw/fLy/fPy/vf3/vj3/vj4/vn5/vr6/vz7//z8//39//7+////wwIZXgAAABF0Uk5TABwdp7u8vL29vr6/v8DA5u1MYiQcAAABb0lEQVRYw+3X2U7CQBQGYKDuWxnwqID7hqCiuOOuICpuuCCVETnv/xR2StVQMvGMjXfzX53+yXyZTJqmEwiIhAwTfk1HQJpgGAhhnVLAABLAumSASQSkAlABmUAHJIICwLr9AqzHL8B6/QKszy/QLqgCrN8v4N2DOuDZAw2ItAgD6kC0BWCDysBwRCoAUYi2EkOqQFs0oIH/BA4tzu/z0/a0X+X88XInJtqjGuf8nARUUeRtBqDuTFhetFtLTA8kgOP2/IaFBQDEYno9j/g0JtqtVGqCCKwAnOKzAHL2cxZxV7RJ6hl4gfgHlhSBXHLTwosvAEr4KtrVuSkq4Bzi7DdwhbWRZpslAnVeLtjrXSD2jjdNtpGhn4GTJrCGeCza9GQClIFiOnPWwEpC6RCruOxO7ov0suS0C1Tg+G7cnfbsV7lyfRAX88ntqP4eaEADGtAABTD/tt5UvPq2xVC8fHsTDv78rpOu/579GyFn6Sc8UES8860f+AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.fc2d2cae7c34da410fab7c9491634462.svg";
export { ForwardRef as ReactComponent };